module.exports = __webpack_public_path__ + "assets/img/img22.cd9c3ccb.png";